import React from 'react';
import { ITableColumn } from '../../Models/Table/ITableColumn';
import { joinClasses } from '../../Utils/className.util';
// @ts-ignore
import styles from './Table.module.scss';
import TableCell from './TableCell';

interface TableRows {
	rows: any;
	columns: ITableColumn[];
}

const TableRows: React.FC<TableRows> = ({ rows, columns }) => {
	const columnsWidth = `calc((100%/${columns.length})`;

	return rows.map((row: any, index: number) => {
		return (
			<React.Fragment key={index}>
				<div
					className={joinClasses([styles.flexTable, styles.flexWrap])}
					role='rowgroup'>
					{columns.map((column, index) => (
						<TableCell
							row={row}
							column={column}
							key={index}
							style={{
								minWidth: column.minWidth ?? columnsWidth,
							}}
						/>
					))}
				</div>
			</React.Fragment>
		);
	});
};

export default TableRows;
